import React from 'react';

export interface WorkflowStep {
  id: number;
  title: string;
  icon: React.ComponentType<{ className?: string }>;
}

interface WorkflowProgressProps {
  workflowSteps: WorkflowStep[];
  currentStep: number;
  className?: string;
  completedStepIds?: number[];
  onClickStep?: (stepId: number, event: React.MouseEvent<HTMLDivElement>) => void;
}

const WorkflowProgress: React.FC<WorkflowProgressProps> = ({ workflowSteps, currentStep, className = '', onClickStep, completedStepIds }) => {
  return (
    <div className={`bg-white border border-gray-200 rounded-lg p-6 ${className}`}>
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900">Workflow Progress</h2>
        <p className="text-sm text-gray-600 mt-1">
          {workflowSteps[currentStep - 1]?.title}
        </p>
      </div>

      <div className="relative">
        {/* Progress Line */}
        <div className="absolute top-6 left-0 right-0 h-0.5 bg-gray-200">
          <div
            className="h-full bg-orange-500 transition-all duration-300"
            style={{ width: `${((currentStep - 1) / (workflowSteps.length - 1)) * 100}%` }}
          />
        </div>

        {/* Steps */}
        <div className="flex justify-between relative z-10">
          {workflowSteps.map((step) => {
            const isActive = step.id === currentStep;
            const isCompleted = completedStepIds?.includes(step.id);
            const isUpcoming = step.id > currentStep;

            return (
              <div key={step.id} className="flex flex-col items-center" onClick={(event: React.MouseEvent<HTMLDivElement>) => { onClickStep && onClickStep(step.id, event); }}>
                {/* Step Circle */}
                <div
                  className={`w-12 h-12 rounded-full flex items-center justify-center mb-2 transition-all duration-300 ${isActive
                    ? 'bg-orange-500 text-white shadow-lg'
                    : isCompleted
                      ? 'bg-green-500 text-white'
                      : 'bg-gray-100 text-gray-400 border-2 border-gray-200'
                    }`}
                >
                  <step.icon className="w-5 h-5" />
                </div>

                {/* Step Button */}
                {/* <button
                  className={`px-3 py-1 rounded-full text-xs font-medium transition-all duration-300 ${
                    isActive 
                      ? 'bg-orange-100 text-orange-700 border border-orange-200' 
                      : isCompleted 
                        ? 'bg-green-100 text-green-700 border border-green-200' 
                        : 'bg-gray-100 text-gray-500 border border-gray-200'
                  }`}
                  disabled={isUpcoming}
                >
                  Step {step.id}
                </button> */}

                {/* Step Title (only show for current step) */}
                {
                  <button className="px-3 py-1 rounded-full transition-all duration-300 text-xs font-medium text-gray-900 text-center" type='button'>
                    {step.title}
                  </button>
                }
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WorkflowProgress; 